import { clsx } from 'clsx';
import { useTranslation } from '@shared/i18n';

interface TelegramStatusBadgeProps {
  linked: boolean;
}

export function TelegramStatusBadge({ linked }: TelegramStatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium',
        linked ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
      )}
    >
      <span
        className={clsx(
          'inline-block w-2 h-2 rounded-full',
          linked ? 'bg-green-500' : 'bg-gray-400'
        )}
      />
      {linked ? t('telegram.connected') : t('telegram.not_connected')}
    </span>
  );
}
